export const ordersConstants = {
    ORDERS_LOADING: "orders_loading",
    ORDERS_LOADED: "orders_loaded",
    ORDERS_ERROR: "orders_error",
}